import { render, staticRenderFns } from "./proFenHai.vue?vue&type=template&id=5e23ed36&scoped=true&"
import script from "./proFenHai.vue?vue&type=script&lang=js&"
export * from "./proFenHai.vue?vue&type=script&lang=js&"
import style0 from "./proFenHai.vue?vue&type=style&index=0&id=5e23ed36&scoped=true&lang=css&"
import style1 from "./proFenHai.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e23ed36",
  null
  
)

export default component.exports